import { cn } from '@g17eco/ui-modern/lib/utils';

interface SidebarItem<T extends string> {
  key: T;
  label: string;
  icon?: React.ReactNode;
  disabled?: boolean;
}

interface InsightsSidebarProps<T extends string> {
  items: SidebarItem<T>[];
  activeItem: T;
  onChange: (item: T) => void;
}

export const InsightsSidebar = <T extends string>({ items, activeItem, onChange }: InsightsSidebarProps<T>) => {
  return (
    <nav className='tw:sticky tw:top-4 tw:w-52 tw:space-y-1 tw:pt-4'>
      {items.map((item) => {
        const isActive = item.key === activeItem;
        return (
          <button
            key={item.key}
            disabled={item.disabled}
            onClick={() => onChange(item.key)}
            className={cn(
              'tw:flex tw:w-full tw:items-center tw:gap-2.5 tw:rounded-md tw:border-0 tw:px-3 tw:py-2 tw:text-sm tw:font-medium tw:transition-colors tw:text-left',
              'tw:cursor-pointer',
              isActive
                ? 'tw:bg-blue-50 tw:text-blue-600'
                : 'tw:bg-transparent tw:text-muted-foreground tw:hover:bg-muted tw:hover:text-foreground',
              item.disabled && 'tw:pointer-events-none tw:opacity-50',
            )}
          >
            {item.icon}
            <span className='tw:truncate'>{item.label}</span>
            {item.disabled && (
              <span className='tw:ml-auto tw:text-[0.6rem] tw:bg-muted tw:text-muted-foreground tw:px-1.5 tw:py-0.5 tw:rounded'>
                Soon
              </span>
            )}
          </button>
        );
      })}
    </nav>
  );
};
